import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import merge from 'lodash/merge';

/**
 * Parameters names passed to the app
 * @type {string}
 */
export const PARAM_OFFICE_SELECTED = 'selectedOfficeId';
export const PARAM_INFO_BLOCKS = 'infoBlocks';
export const PARAM_INFO_BLOCKS_MODAL_INFO = 'modalInfo';
export const PARAM_INFO_BLOCKS_MODAL_TITLE = 'modalTitle';
export const PARAM_LOADED_CALLBACK = 'onModalContentLoaded';

/**
 * Params default values
 * @type {object}
 */
export const getParamsDefault = () => ({
  [PARAM_OFFICE_SELECTED]: null,
  [PARAM_INFO_BLOCKS]: {
    [PARAM_INFO_BLOCKS_MODAL_INFO]: '',
    [PARAM_INFO_BLOCKS_MODAL_TITLE]: 'Выбор города'
  },
  [PARAM_LOADED_CALLBACK]: () => {},
});

/**
 * Takes app's parameters from props
 * @param props
 */
export const extractParams = (props) => {
  const params = [
    PARAM_OFFICE_SELECTED,
    PARAM_INFO_BLOCKS,
    PARAM_LOADED_CALLBACK
  ];
  return merge(getParamsDefault(), pick(props, params));
};

/**
 * Returns prop-types shape for passed parameters
 * @returns {object}
 */
export const getParamsPropShape = () => ({
  [PARAM_OFFICE_SELECTED]: PropTypes.number,
  [PARAM_INFO_BLOCKS]: PropTypes.shape({
    [PARAM_INFO_BLOCKS_MODAL_INFO]: PropTypes.string,
    [PARAM_INFO_BLOCKS_MODAL_TITLE]: PropTypes.string,
  }),
  [PARAM_LOADED_CALLBACK]: PropTypes.func,
});
